import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface HmInfoModalData {
    title: string;
    body: string;
}

const AUTO_CLOSE_MS = 15000;

@Component({
    selector: 'app-hm-info-modal',
    templateUrl: './hm-info-modal.component.html',
    styleUrls: ['./hm-info-modal.component.css', '../../../../assets/css/home-theme.css'],
    standalone: false
})
export class HmInfoModalComponent implements OnInit, OnDestroy {
    private autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(
        public dialogRef: MatDialogRef<HmInfoModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HmInfoModalData
    ) {}

    ngOnInit(): void {
        this.autoCloseTimer = setTimeout(() => {
            this.dialogRef.close();
        }, AUTO_CLOSE_MS);
    }

    ngOnDestroy(): void {
        this.clearAutoCloseTimer();
    }

    private clearAutoCloseTimer(): void {
        if (this.autoCloseTimer != null) {
            clearTimeout(this.autoCloseTimer);
            this.autoCloseTimer = null;
        }
    }
}
